import {createContext} from 'react'

import type {SelectionContextValue} from '../codemirror/extensions/selection-context'

export const SelectionContext = createContext<SelectionContextValue>([])

try{ SelectionContext.displayName ||= 'SelectionContext' } catch {}